<style scoped>
  .list-text{line-height:20px;padding:5px;border-bottom:1px dashed rgb(215, 221, 228);font-size:14px;transition:0.3s all;border-radius:5px;}
  .list-text:hover{background-color:#4fc9ff;color:white}
</style>
<template>
  <span style="display: inline-block;cursor:pointer">
    <Poptip trigger="click" placement="bottom">
      <slot name="title" style="display:inline-block"></slot>
      <div slot="title" style="width:200px">
        <Input suffix="ios-search" @on-change="inputController($event.data)" placeholder="搜索用户并点击添加"></Input>
      </div>
      <div slot="content">
        <ul style="max-height:250px;overflow: auto">
          <li class="list-text" v-for="(item,index) in userList" @click="$emit('selected',item)">{{item.name}}</li>
        </ul>
      </div>
    </Poptip>
  </span>
</template>

<script>
  export default {
    name: "userSelector",
    props:{
      userList:{
        type:Array,
        default:function () {
          return []
        }
      },
      width:{
        type:String,
        default:'200px',
      },
    },
    data:function () {
      return{
        inputTimer:null,
      }
    },
    methods:{
      inputController:function (val) {
        var _this = this
        if(_this.inputTimer!=null){
          clearTimeout(_this.inputTimer)
        }
        setTimeout(function () {
          _this.$emit('inputChange',val)
        },500)
      }
    },
  }
</script>